/**
 * Arc vertical rhythm (AR-578): fixed top bar (60px, TOP_BAR_HEIGHT) ->
 * breathing gap -> page title, identical on every Arc screen and width.
 *
 * ContainerGlobal (components/Layout/styled.tsx) applies the gap as its Arc
 * top padding — the bar itself is already cleared by the container's
 * `margin-top: TOP_BAR_HEIGHT` — so no page ever adds its own top padding
 * and titles never jump when navigating between screens.
 *
 * Kept in a standalone module (same rationale as ArcTopBar/constants) so
 * layout styles can import the tokens without pulling the component graph.
 */
export const ARC_PAGE_TOP_GAP = 32
export const ARC_PAGE_TOP_GAP_MOBILE = 24

/** Legacy ContainerGlobal top paddings (see components/Layout/styled.tsx). */
const LEGACY_CONTENT_TOP_PADDING = 80
const LEGACY_CONTENT_TOP_PADDING_MOBILE = 100

/**
 * Hero screens (absolutely-positioned DashboardHeader anchored at the
 * container top) size their first in-flow offset against the LEGACY top
 * padding. Under Arc the container padding shrinks to ARC_PAGE_TOP_GAP(_
 * MOBILE), so heroes add the difference back to keep the exact same visual
 * clearance below the hero band.
 */
export const arcHeroContentOffset = (legacyOffset: number, isMobile = false) =>
  legacyOffset +
  (isMobile
    ? LEGACY_CONTENT_TOP_PADDING_MOBILE - ARC_PAGE_TOP_GAP_MOBILE
    : LEGACY_CONTENT_TOP_PADDING - ARC_PAGE_TOP_GAP)
